import { render, staticRenderFns } from "./clock-card.vue?vue&type=template&id=1cf007aa"
import script from "./clock-card.vue?vue&type=script&lang=js"
export * from "./clock-card.vue?vue&type=script&lang=js"
import style0 from "./clock-card.vue?vue&type=style&index=0&id=1cf007aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports